import { App } from 'antd';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cancelIcon from 'assets/images/icons/deactivated.svg';
import { useGetSingleIdentityMutation } from 'store/features/process/processApi';

const useIdentitySolutionAction = ({ permissions, id, version, processCode, navigateLink, isAutoSuccessHandler = true }) => {
	const { message: messageApi } = App.useApp();
	const navigate = useNavigate();

	const [action, setAction] = useState(null);
	const [confirmModal, setConfirmModal] = useState(false);
	const [formSubmitData, setFormSubmitData] = useState(null);
	const [modalData, setModalData] = useState({
		head: 'Confirmation',
		label: 'Do you want to update?',
	});

	const [
		updateSingleIdentity,
		{
			data: UpdatedSingleIdentityData,
			error: UpdatedSingleIdentityError,
			isLoading: isOperationLoading,
			isSuccess: isUpdateSuccess,
			isError: isUpdateError,
		},
	] = useGetSingleIdentityMutation();

	const handleSubmit = ({ data = null, actionType }) => {
		if (actionType === 'activeDeactivate') {
			if (!permissions?.edit) {
				messageApi.error({
					content: 'You do not have permission to perform this action.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});

				return;
			}
			setAction(actionType);

			setModalData({
				head: 'Confirmation',
				label: `Do you want to ${data?.activationStatus === 'Active' ? 'deactivate' : 'activate'}?`,
			});
		} else if (actionType === 'create') {
			if (!permissions?.write) {
				messageApi.error({
					content: 'You do not have permission to perform this action.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});

				return;
			}

			setAction(actionType);

			setModalData({
				head: 'Confirmation',
				label: 'Do you want to create?',
			});

			setFormSubmitData(data);
		} else if (actionType === 'approve-single') {
			if (!permissions?.approve) {
				messageApi.error({
					content: 'You do not have permission to perform this action.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});

				return;
			}

			setAction(actionType);

			setModalData({ head: 'Confirmation', label: 'Do you want to approve?' });
		} else if (actionType === 'reject-single') {
			if (!permissions?.reject) {
				messageApi.error({
					content: 'You do not have permission to perform this action.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});

				return;
			}
			setAction(actionType);

			setModalData({ head: 'Confirmation', label: 'Do you want to reject?' });
		} else if (actionType === 'update') {
			if (permissions?.edit === false) {
				messageApi.error({
					content: 'You do not have permission to perform this action.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});

				return;
			}
			setAction(actionType);
			setFormSubmitData(data);
		}

		setConfirmModal(true);
	};

	const handleActiveDeactivate = (activationStatus) => {
		const payload = {
			_id: id,
			version,
			processCode,
			suffixCode: '',
			operation: 'activate-single',
			activationStatus: activationStatus === 'Active' ? 'Inactive' : 'Active',
		};

		updateSingleIdentity(payload);
	};

	const handleApproveReject = (operation) => {
		updateSingleIdentity({
			_id: id,
			operation,
			processCode,
			suffixCode: '',
		});
	};

	const handleUpdate = (data) => {
		if (processCode && id && version) {
			updateSingleIdentity({
				data,
				version,
				_id: id,
				processCode,
				suffixCode: '',
				operation: 'update-single',
			});
		}
	};

	const handleCreate = (data) => {
		if (processCode && data) {
			updateSingleIdentity({
				data,
				processCode,
				suffixCode: '',
				operation: 'add-single',
			});
		}
	};

	useEffect(() => {
		if (isAutoSuccessHandler) {
			if (UpdatedSingleIdentityData?.code === '501' || UpdatedSingleIdentityData?.code === '502') {
				toast.error(UpdatedSingleIdentityData?.message, toastConfig);
			} else if (isUpdateSuccess) {
				toast.success('Success! Action completed.', toastConfig);

				navigate(navigateLink ? navigateLink : -1);
			} else if (isUpdateError) {
				toast.error('Failure! Action not completed.', toastConfig);
			}
		}
	}, [isUpdateError, isUpdateSuccess]);

	return {
		action,
		setAction,
		modalData,
		handleCreate,
		handleUpdate,
		handleSubmit,
		confirmModal,
		setModalData,
		formSubmitData,
		setConfirmModal,
		isUpdateSuccess,
		isUpdateError,
		UpdatedSingleIdentityError,
		isOperationLoading,
		handleApproveReject,
		handleActiveDeactivate,
	};
};

export default useIdentitySolutionAction;